import { observer } from 'mobx-react'
import { useActivation } from '../../../../hooks/mobx-hooks'
import WorkspacePostingOpportunitiesViewModel from '../../WorkspacePostingOpportunitiesViewModel'
import * as React from 'react'
import {
  useSideSheet,
  SideSheetMain,
  SideSheetHostView,
  SideSheetElevation,
} from '../../../../components/SideSheet'
import { useScrollOffsetSpring } from '../../../../hooks/spring-hooks'
import styles from './WorkspaceOpportunitiesView.sass'
import {
  StickyViewHeader,
  StickyViewHeaderSpacer,
} from '../../../../components/StickyViewHeader'
import { ViewHeading } from '../../../../components/ViewHeading'
import StaffingAnnouncementBanner from '../../../components/StaffingAnnouncementBanner'
import WorkspaceOpportunityDetailsSheet from '../WorkspaceOpportunityDetailsSheet'
import WorkspaceOpportunitiesList from '../WorkspaceOpportunitiesList'
import ResultCounts from '../../../../jobs/components/ResultCounts'
import {
  ContentLayout,
  ContentMain,
} from '../../../../components/ContentLayout'

interface WorkspaceOpportunitiesViewProps {
  vm: WorkspacePostingOpportunitiesViewModel
  tabBars: React.ReactNode
}

export default observer(function WorkspaceOpportunitiesMainView({
  vm,
  tabBars,
}: WorkspaceOpportunitiesViewProps) {
  useActivation(vm)

  const sideSheet = useSideSheet()
  const scrollRef = React.useRef<HTMLDivElement | null>(null)
  const scrollOffset = useScrollOffsetSpring(scrollRef)
  const visible = !!vm.detailsVM.selected || !sideSheet.shouldBeAbove

  return (
    <>
      <SideSheetHostView
        sheetVisible={visible}
        elevation={sideSheet.elevation}
        onRequestHide={vm.detailsVM.deselect}
      >
        <SideSheetMain>
          <div className={styles.root} ref={scrollRef}>
            <StickyViewHeader scrollOffset={scrollOffset} tabBar={tabBars}>
              <ViewHeading
                primaryText="Opportunities"
                isDropdown={false}
                secondaryText="All Workspaces"
              />
              <StickyViewHeaderSpacer />
            </StickyViewHeader>
            <ContentLayout accountForTabBar={Boolean(tabBars)}>
              <ContentMain>
                <div className={styles.banner}>
                  <StaffingAnnouncementBanner />
                </div>
                <div className={styles.resultsCount}>
                  <ResultCounts
                    showing={vm.opportunities.length}
                    total={null}
                  />
                </div>
                <WorkspaceOpportunitiesList vm={vm} />
              </ContentMain>
            </ContentLayout>
          </div>
        </SideSheetMain>
        <WorkspaceOpportunityDetailsSheet
          vm={vm.detailsVM}
          onCloseClick={
            sideSheet.elevation === SideSheetElevation.Above
              ? vm.detailsVM.deselect
              : undefined
          }
        />
      </SideSheetHostView>
    </>
  )
})
